export default {
  segments: [],
  segmentsParams: {},
  createSegmentModalIsActive: false,
  selectedSegmentForSend: {},
  clientsInSelectedSegment: -1,
  newSegmentForm: {
    name: '',
    description: '',
  },
}
